import { Tooltip, IconButton } from '@material-ui/core'
import { makeStyles } from "@material-ui/core/styles"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { useSelector, useDispatch } from "react-redux"
import { targetBancoAction, eliminarBancoAction, obtenerBancosAllAction } from "../../../../ducks/bancoGeneralDuck"
import { onLoadAnction, offLoadAction } from '../../../../ducks/loadDuck'
import { ToastMessage } from '../../../../global/ToastMessage'
import { yellow } from '@material-ui/core/colors'
const columns = [
    { id: "Nombre", minWidth: 150, align: "center", label: "Nombre" },
    { id: "TasaCobro", minWidth: 30, align: "center", label: "Tasa de cobro" },
    { id: "Accion", minWidth: 30, align: "center", label: "" },
]

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    container: {
        maxHeight: 440,
    },
})

const TBancoMain = () => {
    const classes = useStyles()
    const { bancosMain } = useSelector(store => store.bancoMain)
    const dispatch = useDispatch()
    const handleEdit = ({ banco }) => {
        dispatch(targetBancoAction({ banco, editar: true }))
    }
    const handleEliminar = ({ banco }) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(eliminarBancoAction({ idBanco: banco.IdBancoGeneral })).then(Response => {
            dispatch(offLoadAction())
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "error",
                    title: Response.Message,
                });
                return null;
            }
            dispatch(obtenerBancosAllAction())
            ToastMessage.fire({
                icon: "success",
                title: "Ingreso Correcto",
            });
        })
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {bancosMain.map((row, index) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.IdBancoGeneral}>
                                    <TableCell align="center">{`${row.Nombre}`}</TableCell>
                                    <TableCell align="center">{`${row.TasaGeneral} %`}</TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Edutar">
                                            <IconButton
                                                aria-label="Edutar"
                                                onClick={() => { handleEdit({ banco: row }) }}
                                            >
                                                <EditIcon  style={{ color: yellow[500] }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Eliminar">
                                            <IconButton
                                                aria-label="Eliminar"
                                                onClick={() => { handleEliminar({ banco: row }) }}
                                            >
                                                <DeleteIcon color='error' />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    )
}
export default TBancoMain
